<pwj-media-videos-grid
  [videos]="videos()"
  [showTitle]="true"
  titleKey="global.video" />
